import React from 'react';
import styled from 'styled-components';
import { registry } from '../../core/Registry.js';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  width: ${props => props.size || '160px'};
  margin: ${props => props.align === 'center' ? '0 auto' : '0'};
`;

const SVG = styled.svg`
  transform: rotate(-90deg);
  width: 100%;
  height: 100%;
`;

const CircleBg = styled.circle`
  fill: none;
  stroke: var(--glass-2);
  stroke-width: ${props => props.thickness || '12'};
`;

const CircleProgress = styled.circle`
  fill: none;
  stroke: ${props => props.color || 'var(--accent)'};
  stroke-width: ${props => props.thickness || '12'};
  stroke-dasharray: ${props => props.circumference};
  stroke-dashoffset: ${props => props.offset};
  stroke-linecap: round;
  transition: stroke-dashoffset 1.5s ease;
`;

const InnerText = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  
  .val { font-size: 32px; font-weight: 900; color: var(--text-primary); }
  .label { font-size: 12px; color: var(--text-muted); text-transform: uppercase; letter-spacing: 1px; }
`;

const Title = styled.h4`
  margin: 15px 0 0 0;
  color: var(--text-primary);
  text-align: center;
`;

const CircleProgressWidget = ({ node }) => {
  const percent = parseInt(node.content?.percent || 75);
  const size = 160;
  const thickness = parseInt(node.style?.desktop?.thickness || 12);
  const radius = (size - thickness) / 2;
  const circumference = radius * 2 * Math.PI;
  const offset = circumference - (percent / 100) * circumference;

  return (
    <Wrapper align={node.style?.desktop?.align} size={`${size}px`}>
      <SVG viewBox={`0 0 ${size} ${size}`}>
        <CircleBg cx={size/2} cy={size/2} r={radius} thickness={thickness} />
        <CircleProgress cx={size/2} cy={size/2} r={radius} thickness={thickness} 
          circumference={circumference} offset={offset} color={node.style?.desktop?.color} />
      </SVG>
      <InnerText>
        <div className="val">{percent}%</div>
        <div className="label">Abgeschlossen</div>
      </InnerText>
      {node.content?.title && <Title>{node.content?.title}</Title>}
    </Wrapper>
  );
};

registry.register('circle_progress', {
  label: 'Kreis Chart',
  icon: '🍩',
  category: 'advanced',
  defaultContent: {},
  defaultStyle: { desktop: { align: 'center', color: 'var(--accent)', thickness: '12' } },
  render: CircleProgressWidget,
  inspectorControls: [
    { tab: 'content', groups: [{ title: 'Werte', fields: [{name:'content.percent', label:'Prozent (0-100)', type:'number'}, {name:'content.title', label:'Untertext', type:'text'}] }] },
    { tab: 'style', groups: [{ title: 'Design', fields: [{name:'style.desktop.color', label:'Farbe', type:'text'}, {name:'style.desktop.thickness', label:'Dicke (px)', type:'number'}, {name:'style.desktop.align', label:'Ausrichtung', type:'select', options:[{label:'Links', value:'flex-start'},{label:'Centriert', value:'center'}]}] }] }
  ]
});
